export const SIGN_UP_GYM_ACCOUNT_FORM = 'SIGN_UP_GYM_ACCOUNT_FORM';
export const SIGN_UP_USER_ACCOUNT_FORM = 'SIGN_UP_USER_ACCOUNT_FORM';
export const SIGN_IN_USER_VIA_EMAIL_FORM = 'SIGN_IN_USER_VIA_EMAIL_FORM';

export const RESET_PASSWORD_FIELD = 'RESET_PASSWORD_FIELD';

export const CONFIRM_RESET_PASSWORD = 'CONFIRM_RESET_PASSWORD';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/FormActionTypes.js